import React from 'react';

import { ListRow, Text } from '@betterment/samba-react';

import { formatContributionValue } from './payrollContributionUtils';

import { PayrollContributionConfigFragment } from '../../../graphql/fragments/payrollContributionConfig.generated';

type Props = {
  config: PayrollContributionConfigFragment;
};

export const PayrollContributionConfigRow: React.FC<Props> = ({ config }) => {
  const baseText = formatContributionValue(config.value, config.destinationName);

  return (
    <ListRow key={config.id} css={{ padding: 'space.0', alignItems: 'start' }}>
      <ListRow.LeadingContent>
        <Text>{baseText}</Text>
      </ListRow.LeadingContent>
    </ListRow>
  );
};
